// extracted by mini-css-extract-plugin
export default {"button":"CrewVoiceIconButton_button","animate":"CrewVoiceIconButton_animate","wave":"CrewVoiceIconButton_wave"};